import { useMemo } from 'react'
import { format } from 'date-fns'
import SelectionCell from '../SelectionCell'
import FormNameCell from '../FormNameCell'
import ActionButtons from '../ActionButtons'
import SortableHeader from '../SortableHeader'

/**
 * Custom hook for table column definitions
 */
export const useTableColumns = ({
    selectedForm,
    readonly,
    onFormClick,
    onDuplicate,
    onArchive,
    onUnarchive,
    onEdit,
}) => {
    return useMemo(
        () => [
            // Selection column (radio button)
            {
                id: 'select',
                header: '',
                cell: ({ row }) => (
                    <SelectionCell
                        form={row.original}
                        selectedForm={selectedForm}
                        onFormClick={onFormClick}
                        readonly={readonly}
                    />
                ),
                enableSorting: false,
                enableHiding: false,
            },
            // Form name column
            {
                accessorKey: 'name',
                header: ({ column }) => <SortableHeader title="Title" column={column} />,
                cell: ({ row }) => <FormNameCell form={row.original} />,
            },
            // Number of fields column
            {
                accessorKey: 'questions',
                header: ({ column }) => (
                    <div className="tw:text-right tw:pr-2">
                        <SortableHeader title="Fields" column={column} />
                    </div>
                ),
                cell: ({ row }) => (
                    <span className="tw:text-right tw:block tw:pr-2">{row.original.questions.length}</span>
                ),
                sortingFn: (rowA, rowB) => {
                    const lengthA = rowA.original.questions.length
                    const lengthB = rowB.original.questions.length
                    return lengthA - lengthB
                },
            },
            // Creation date column
            {
                accessorKey: 'created_time',
                header: ({ column }) => <SortableHeader title="Created Date" column={column} />,
                cell: ({ row }) => (
                    <span>
                        {row.original.created_time ? format(new Date(row.original.created_time), 'd MMM yyyy') : ''}
                    </span>
                ),
            },
            // Actions column
            {
                id: 'used',
                header: () => <div className="tw:text-right tw:pr-6">Used</div>,
                cell: ({ row, isHovered }) => (
                    <div className="tw:text-right tw:pr-6">
                        <ActionButtons
                            form={row.original}
                            onDuplicate={onDuplicate}
                            onArchive={onArchive}
                            onUnarchive={onUnarchive}
                            onEdit={onEdit}
                            isHovered={isHovered}
                        />
                    </div>
                ),
            },
        ],
        [selectedForm, readonly, onFormClick, onDuplicate, onArchive, onUnarchive, onEdit],
    )
}
